import type { RestClient } from "./restClient";

export interface ArtifactRecord {
  artifact_id: string;
  status: string;
  type?: string;
  title?: string | null;
}

/** Wraps the unified_agent artifact lifecycle endpoints. Only used for
 *  artifacts in `pending_review`: approve runs the commit handler, edit
 *  replaces the body before approval, reject discards without committing. */
export class ArtifactsApi {
  constructor(private rest: RestClient) {}

  approve(artifactId: string): Promise<ArtifactRecord> {
    return this.rest.post<ArtifactRecord>(`/artifacts/${artifactId}/approve`);
  }

  reject(artifactId: string): Promise<ArtifactRecord> {
    return this.rest.post<ArtifactRecord>(`/artifacts/${artifactId}/reject`);
  }

  edit(artifactId: string, content: string): Promise<ArtifactRecord> {
    return this.rest.put<ArtifactRecord>(`/artifacts/${artifactId}`, { content });
  }
}
